import PolicyPDF from "../components/PolicyPDF";
import "../css/policy.css";

const sections = [
  {
    title: "1. Delivery and Collection",
    paragraphs: [
      "Completed orders may be collected from the IGC Print Press pressroom or delivered where delivery is available for the relevant order and destination.",
    ],
  },
  {
    title: "2. Collection Location",
    paragraphs: [
      "Customers collecting orders should use the following location:",
      "CBU Mall, Igwuruta, Along Eneka Road, Port Harcourt, Rivers State, Nigeria.",
    ],
  },
  {
    title: "3. Delivery Charges",
    paragraphs: [
      "Delivery charges may depend on the destination, order size, quantity, urgency, and delivery method. Where applicable, the delivery charge will be communicated before delivery is arranged.",
    ],
  },
  {
    title: "4. Delivery Timeline",
    paragraphs: [
      "Delivery normally takes place after production has been completed and the order is ready for dispatch.",
      "The delivery timeline may vary depending on the destination, courier availability, traffic, weather, and other circumstances outside our reasonable control.",
    ],
  },
  {
    title: "5. Customer Information",
    paragraphs: [
      "Customers are responsible for providing accurate delivery information, including the recipient's name, phone number, and delivery address.",
      "Delays or failed deliveries resulting from incorrect or incomplete information may result in additional delivery arrangements or charges.",
    ],
  },
  {
    title: "6. Receiving an Order",
    paragraphs: [
      "Customers or their authorised representatives should inspect delivered orders where reasonably possible and notify IGC Print Press promptly if there is a significant issue with the received order.",
    ],
  },
  {
    title: "7. Delayed or Failed Delivery",
    paragraphs: [
      "If a delivery cannot be completed because the recipient is unavailable, the address is inaccessible, or the information provided is incorrect, another delivery attempt may need to be arranged.",
    ],
  },
  {
    title: "8. Collection by Another Person",
    paragraphs: [
      "A customer may authorise another person to collect an order where appropriate. The person collecting may be asked to provide sufficient order or customer information to identify the order.",
    ],
  },
  {
    title: "9. Contact",
    paragraphs: [
      "For delivery or collection enquiries, contact IGC Print Press on +234 803 773 8028.",
    ],
  },
];

export default function DeliveryPolicy() {
  return (
    <div className="policy-page">
      <div className="wrap">
        <div className="policy-hero">
          <span className="hero-tag">
            <span className="pulse" />
            IGC PRINT PRESS
          </span>

          <h1 className="policy-title">
            Delivery Policy
          </h1>

          <p className="policy-intro">
            Information about order collection, delivery arrangements,
            timelines, delivery charges, and receiving completed printing
            orders.
          </p>

          <span className="policy-updated">
            Last updated: September 2026
          </span>
        </div>

        <PolicyPDF
          title="Delivery Policy"
          filename="IGC-Print-Press-Delivery-Policy.pdf"
          sections={sections}
        >
          <div className="policy-content">
            {sections.map((section) => (
              <section key={section.title}>
                <h2>{section.title}</h2>

                {section.paragraphs?.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </section>
            ))}
          </div>
        </PolicyPDF>
      </div>
    </div>
  );
}